import React from 'react';
import styles from './SecondScreen.module.css';
import Button from '../../components/button/Button';

const SecondScreen = () => {
  const painPoints = [
    "השיווק גוזל ממך זמן יקר וזה בא על חשבון המשפחה שלך וניהול העסק שלך",
    "את סופר מקצועית אבל העמוד שלך נראה מבולגן ולא משדר את האיכות שלך בעסק",
    "את משקיעה בקמפיין ממומן אבל הלידים מגיעים מאוד קרים וקשה לך לסגור אותם",
    "יש בך פחד שכדי להצליח ברשתות את חייבת לחשוף את כל החיים האישיים שלך",
    "את מסתכלת על אנשים בתחום שלך ועסוקה בהשוואות ולמה אצלך השיווק לא עובד"
  ];

  const solutions = [
    "השיווק שלך יעבוד בשבילך ולא את בשבילו. את תתעסקי בניהול העסק שלך והפיתוח שלו בזמן שהעמוד שלך יצור בשבילך תנועה סביב השעון.",
    "העמוד שלך יראה כמו כרטיס ביקור מתוקתק וכל מה שיכנס לעמוד שלך יבין שיש פה עסק רציני וכבר מהרגע הראשון שיכנסו לעמוד יבינו שמישהי פה מבינה מה היא עושה.",
    "העמוד שלך יהפוך למכונת מכירה וההשקעות על הקמפיינים הממומנים סוף סוף יתחילו לחזור לעסק שלך ולהכפיל את עצמם עוד ועוד.",
    "העמוד שלך יחשף לאנשים וקהל חדש על בסיס הידע והאישיות שלך בלי לעשות קרקסים ולחשוף את כל הדברים שאת רוצה להשאיר לעצמך.",
    "את תפסיקי להתעסק בלהשוות את עצמך לאחרים (טוב אולי קצת כי זה טבע האדם אין מה לעשות…) אבל השיווק שלך יהיה ברמה גבוהה שתפסיקי להתבאס על זה שאצל המתחרה שלך זה נראה טוב ואצלך לא."
  ];

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>

        {/* Section 1: Pain points */}
        <h2 className={styles.sectionTitle}>אם את מרגישה ש...</h2>
        <div className={styles.grid}>
          {painPoints.map((point, index) => (
            <div key={index} className={styles.painCard}>
              <div className={styles.painDot}>✗</div>
              <p className={styles.cardText}>{point}</p>
            </div>
          ))}
        </div>

        {/* Section 2: Change moment */}
        <div className={styles.changeSection}>
          <h2 className={styles.changeTitle}><span className={styles.changeTitleHighlight}>הגיע הזמן לשינוי.</span></h2>
          <p className={styles.changeText}>
            ברגע שאת מפרסמת עם אסטרטגיה נכונה לקהל היעד שלך שעונה על כל ההתנגדויות שלהם לפני שיחת המכירה, בונה משפכים שיווקיים למוצרים שלך ויודעת בדיוק איזה מסע חימום הלקוח שלך עובר, הלידים שלך מגיעים חמים ואת תפסיקי לנסות כל פעם להוכיח את עצמך מחדש - כי את יודעת מה את שווה!
          </p>
        </div>

        {/* Section 3: Solutions */}
        <h2 className={styles.sectionTitle}>אם תעשי את השינוי,</h2>
        <div className={styles.grid}>
          {solutions.map((solution, index) => (
            <div key={index} className={styles.solutionCard}>
              <div className={styles.solutionDot}>✓</div>
              <p className={styles.cardText}>{solution}</p>
            </div>
          ))}
        </div>

        <Button text="נטלי, בואי נדבר!" />
      </div>
    </section>
  );
};

export default SecondScreen;
